module.exports = __webpack_public_path__ + "static/media/whitesquare.48db247c.png";